import axios from 'axios';
import { refreshClientToken } from './client-api';
import Cookie from 'js-cookie';

const locationapi = axios.create( {
    baseURL: import.meta.env.TWC_LOCATION_URL,
    validateStatus: function( status ) {
        return status >= 200 && status < 500;
    },
} );

let handleRequest = async ( request ) => {
    const token = Cookie.get( 'access_token' );

    if ( token ) {
        request.headers.Authorization = `Bearer ${token}`;
    }

    return request;
};

let handleResponse = async ( response ) => {
    const status = response.status;

    // unathorized (try to refresh token?)
    if ( status === 401 ) {
    // check if we already tried
        if ( response.config._retry ) {
            return response;
        }

        if ( await refreshClientToken() ) {
            response.config._retry = true;
            return locationapi.request( response.config );
        }
    }

    return response;
};

const handleError = ( error ) => {
    return Promise.reject( error );
};

locationapi.interceptors.request.use( handleRequest, handleError );
locationapi.interceptors.response.use( handleResponse, handleError );

export default locationapi;
